import { updateUserProfile } from '../../../../../../../api/rest/updateUserProfile';
import { validateRecaptcha } from '../../../../../../../api/rest/validateRecaptcha';
import {
  CURRENT_CONSENT_MARKETING_EMAIL_UUID,
  SIGNUP_METHODS,
} from '../../../../../../../constants/constants';
import { createUserAndSignIn } from '../../../../../../../helpers/authentication/authentication';
import { Context } from '../../types';

interface AuthenticationArgs {
  helpers: Context['helpers'];
  standardAuth: Context['standardAuth'];
}

export const handleStandardAuth = async ({
  helpers,
  standardAuth,
}: AuthenticationArgs): Promise<void> => {
  const { checkForTokens, getToken, setSignupMethod, updateConsent } = helpers;
  const { account, reCaptcha } = standardAuth;
  const { acceptsEmail, email, password, firstName, lastName } = account;
  const { ref } = reCaptcha;
  const reCaptchaToken = await ref.current.executeAsync();

  await validateRecaptcha(reCaptchaToken, 'mykiss_invisible', getToken);
  setSignupMethod(SIGNUP_METHODS.manual);
  await createUserAndSignIn(email, password);
  await Promise.all([
    updateConsent(CURRENT_CONSENT_MARKETING_EMAIL_UUID, acceptsEmail),
    updateUserProfile({ first_name: firstName, last_name: lastName }, getToken),
  ]);
  await checkForTokens();
};
